import { ApiResult, request, safeRequest } from '@synergy/api';

import { NewsPost } from '../../models/news-post';
import { NewsPostDetailRequest } from '../models/news-post-detail-request';

export class NewsPostDetailApi {
    constructor(protected baseUrl: string) {}

    public getNewsPostDetail(id: number): Promise<ApiResult<NewsPost>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/news-posts/${id}`),
            response => response.data
        );
    }

    public updateNewsPostDetail = (newsPost: NewsPostDetailRequest): Promise<ApiResult<NewsPost>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/news-posts/${newsPost.id}/update`, newsPost),
            response => response.data
        );
    };

    public createNewsPostDetail = (newsPost: NewsPostDetailRequest): Promise<ApiResult<NewsPost>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/news-posts/create`, newsPost),
            response => response.data
        );
    };
}
